import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BillingToggle from '../common/BillingToggle';
import styles from './PricingPreview.module.css';

const PLANS = [
  { name: 'Solo', monthly: 59, annual: 49, unit: '/mo', featured: false, leads: '150 verified leads / mo' },
  { name: 'Pro', monthly: 119, annual: 99, unit: '/mo', featured: true, leads: '500 verified leads / mo' },
  { name: 'Team', monthly: 119, annual: 99, unit: '/user/mo', featured: false, comingSoon: true, leads: '500 verified leads / mo' },
];

export default function PricingPreview() {
  const navigate = useNavigate();
  // Monthly by default, matching the pricing page: the first number a visitor sees should be
  // the monthly commitment, with the annual saving offered rather than presumed.
  const [billing, setBilling] = useState('monthly');

  return (
    <section className={styles.section} aria-label="Pricing preview">
      <div className={styles.inner}>
        {/* Centered Annual/Monthly toggle - shared with the Pricing page */}
        <BillingToggle billing={billing} onChange={setBilling} className={styles.toggleSpacing} />

        <div className={styles.cards}>
          {PLANS.map((p) => {
            const active = billing === 'annual' ? p.annual : p.monthly;
            const alt =
              billing === 'annual'
                ? `billed annually · $${p.monthly}${p.unit} monthly`
                : `or $${p.annual}${p.unit} billed annually`;
            return (
              <div
                key={p.name}
                className={`${styles.card} ${p.featured ? styles.featured : ''} ${p.comingSoon ? styles.comingSoon : ''}`}
              >
                {p.featured && <span className={styles.badge}>Most popular</span>}
                {p.comingSoon && <span className={styles.badgeSoon}>Coming soon</span>}
                <span className={styles.planName}>{p.name}</span>

                <div className={styles.priceBlock}>
                  {p.comingSoon ? (
                    <div className={styles.priceMain}>
                      <span className={styles.price}>TBD</span>
                    </div>
                  ) : (
                    <>
                      {/* key re-triggers the fade/slide each time billing switches */}
                      <div key={billing} className={styles.priceMain}>
                        <span className={styles.price}>${active}</span>
                        <span className={styles.unit}>{p.unit}</span>
                      </div>
                      <span className={styles.priceAlt}>{alt}</span>
                    </>
                  )}
                </div>

                <span className={styles.leads}>{p.leads}</span>
              </div>
            );
          })}
        </div>

        <div className={styles.actions}>
          <button className={styles.fullBtn} onClick={() => navigate('/pricing')}>
            See full pricing
          </button>
        </div>
      </div>
    </section>
  );
}
